import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast, Toast, ToastVariant } from '@hungryroot/components-toast';
import { StatusCode } from '@hungryroot/rest';

import {
  type UnskipOrderData,
  patchApiV2CustomersCustomerIdOrdersId,
} from '@hungryroot/rest/api/v2/customers/[id]/orders/[order_id]/patch';
import { invalidatePastCurrentUpcomingOrders } from '../utils/invalidatePastCurrentUpcomingOrders';

export function useUnskipOrder() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (params: { data: UnskipOrderData }) => {
      const { data } = params;
      const res = await patchApiV2CustomersCustomerIdOrdersId({
        orderId: data.id,
        requestBody: { status: 20 },
      });

      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }

      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['Orders'] });
      invalidatePastCurrentUpcomingOrders(queryClient);
      toast(
        <Toast testid="toast-unskip" variant={ToastVariant.Neutral}>
          Woohoo! Your delivery is unskipped.
        </Toast>
      );
    },
  });
}
